import { type IconProps } from 'components/Shared/Icon/index';
import { iconStyles } from 'components/Shared/Icon/iconStyles';
import styles from './styles.scss';
import cn from 'classnames';

export const IconVisa = (props: IconProps) => (
  <svg
    viewBox="0 0 400 260"
    xmlns="http://www.w3.org/2000/svg"
    className={cn(iconStyles(props), styles.removeStroke)}
  >
    <path
      d="m238.72 77.91c-22.8 0-43.27 11.89-43.27 33.71 0 25.13 36.16 26.84 36.16 39.35 0 5.27-6.13 10.05-16.42 10.05-14.71 0-25.74-6.62-25.74-6.62l-4.66 22.06s12.63 5.64 29.54 5.64c25 0 44.62-12.38 44.62-34.69 0-26.48-36.28-28.19-36.28-39.84 0-4.17 5.03-8.7 15.32-8.7 11.64 0 21.21 4.78 21.21 4.78l4.66-21.33c-.12 0-10.54-4.41-25.13-4.41zm-208.86 1.59-.61 3.19s9.56 1.72 18.26 5.27c11.15 4.04 11.89 6.37 13.85 13.61l20.47 78.81h27.46l42.04-100.88h-27.33l-27.09 68.64-11.03-58.22c-.98-6.62-6.13-10.42-12.5-10.42h-43.51zm132.5 0-21.45 100.88h26.11l21.33-100.88zm145.37 0c-6.25 0-9.56 3.31-12.01 9.19l-38.24 91.68h27.33l5.27-15.32h33.34l3.19 15.32h24.15l-20.96-100.88h-22.06zm3.56 27.33 8.09 37.88h-21.7z"
      fill="#1434cb"
    />
  </svg>
);
